/**
 * Created by dushyantha on 7/12/16.
 */
(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name crewSchedule.directive:crewScheduleSearch
   * @restrict EA
   * @element
   *
   */
  angular
  .module('crewSchedule')
  .directive('crewScheduleSearch', crewScheduleSearch)
  .directive('focusOn',function($timeout) {
    return {
      restrict : 'A',
      link : function(vm,$element,$attr) {
        vm.$watch($attr.focusOn,function(_focusVal) {
          $timeout(function() {
            _focusVal ? $element[0].focus() :
              $element[0].blur();
          });
        });
      }
    }
  });

  function crewScheduleSearch(applicationConstants) {
    return {
      restrict: 'EA',
      scope: {
        openSearchPanel:'&',
        onChangeCrewType: '&',
        onChangeEmployeeHub:'&',
        searchCrewSchedule:'&',
        crewTypes: '=',
        baseTypes : '=',
        employerHubs: '=',
        filterTypes : '=',
        crewList : '=',
        showSearchPanel :'=',
        searchModule:'='
      },
      templateUrl: 'crew-schedule/directives/crew-schedule-search-directive.tpl.html',
      replace: false,
      controllerAs: 'crewScheduleSearch',
      bindToController: true,

      controller: ['$scope','MessageService', function ($scope,MessageService) {
        var vm = this;
        if(vm.searchModule === undefined){
          vm.model = {
            fromDate :'',
            toDate : '',
            crewBase:{airPortCode:''},
            crewType:{crewTypeCode:''},
            employerHub:{hubCode:''},
            filterBy:{value:''},
            days:'',
            crewDetails:'',
            crewID:'',
            hubCode:''
          };
        }
        else{
          vm.model= vm.searchModule;
        }
        vm.selectedCrew = null;
        vm.storedSearchValue = null;
        vm.flag = 1;
        vm.filterBy = null;
        vm.model.filterTypes = [
          {
            value: 'firstName',
            label: 'First Name'
          },
          {
            value: 'lastName',
            label: 'Last Name'
          }
        ];


        setDefaultSearchDays();
        vm.displaySearchArea = function () {
          vm.openSearchPanel();
        };

        vm.displaySearchArea();

        // vm.setSelectedCrewDetails = function(){
        //   if(vm.flag == 0)
        //     vm.model.crewDetails = null;
        //   else
        //   vm.model.crewDetails = vm.selectedCrew;
        // }

        vm.getFilteredValue=function (input) {
          if(vm.model.filterBy==null){
            if(vm.selectedCrew != null && vm.flag==1){
              vm.flag = 0;
              input = vm.storedSearchValue;
              vm.startingfrom = 0;
              if(input == " "){
                return vm.crewList.filter(function (crew) {
                  if(vm.startingfrom == 0){
                    if(crew['displayName']!=vm.selectedCrew.displayName){return null;}
                    else{vm.startingfrom = 1;return crew['displayName'];}}
                  return crew['displayName'];
                });
              }
              else{
                return vm.crewList.filter(function (crew) {
                  if(vm.startingfrom == 0){
                    if(crew['displayName']!=vm.selectedCrew.displayName){return null;}
                    else{vm.startingfrom = 1;return crew['displayName'].substr(0, input.length).toLowerCase() == input.toLowerCase();}}
                  return crew['displayName'].substr(0, input.length).toLowerCase() == input.toLowerCase();
                });}
            }
            if(input == " "){
              vm.storedSearchValue=input;
              return vm.crewList;
            }else{
              vm.storedSearchValue=input;
              return vm.crewList.filter(function (crew) {
                return crew['displayName'].substr(0, input.length).toLowerCase() == input.toLowerCase();
              });}

          }else{
            if(vm.model.filterBy.value=="lastName"){
              if(vm.selectedCrew != null && vm.flag==1){
                vm.flag = 0;
                input = vm.storedSearchValue;
                vm.startingfrom = 0;
                if(input == " "){
                  return vm.crewList.filter(function (crew) {
                    if(vm.startingfrom == 0){
                      if(crew['lastName']!=vm.selectedCrew.lastName){return null;}
                      else{vm.startingfrom = 1;return crew['lastName'];}}
                    return crew['lastName'];
                  });
                }
                else{
                  return vm.crewList.filter(function (crew) {
                    if(vm.startingfrom == 0){
                      if(crew['lastName']!=vm.selectedCrew.lastName){return null;}
                      else{vm.startingfrom = 1;return crew['lastName'].substr(0, input.length).toLowerCase() == input.toLowerCase();}}
                    return crew['lastName'].substr(0, input.length).toLowerCase() == input.toLowerCase();
                  });}
              }
              if(input == " "){
                vm.storedSearchValue=input;
                return vm.crewList;
              }else{
                vm.storedSearchValue=input;
                return vm.crewList.filter(function (crew) {
                  return crew['lastName'].substr(0, input.length).toLowerCase() == input.toLowerCase();
                });}
            }
            else{
              if(vm.selectedCrew != null && vm.flag==1){
                vm.flag = 0;
                input = vm.storedSearchValue;
                vm.startingfrom = 0;
                if(input == " "){
                  return vm.crewList.filter(function (crew) {
                    if(vm.startingfrom == 0){
                      if(crew['firstName']!=vm.selectedCrew.firstName){return null;}
                      else{vm.startingfrom = 1;return crew['firstName'];}}
                    return crew['firstName'];
                  });
                }
                else{
                  return vm.crewList.filter(function (crew) {
                    if(vm.startingfrom == 0){
                      if(crew['firstName']!=vm.selectedCrew.firstName){return null;}
                      else{vm.startingfrom = 1;return crew['firstName'].substr(0, input.length).toLowerCase() == input.toLowerCase();}}
                    return crew['firstName'].substr(0, input.length).toLowerCase() == input.toLowerCase();
                  });}
              }
              if(input == " "){
                vm.storedSearchValue=input;
                return vm.crewList;
              }else{
                vm.storedSearchValue=input;
                return vm.crewList.filter(function (crew) {
                  return crew['firstName'].substr(0, input.length).toLowerCase() == input.toLowerCase();
                });}
            }
          }
        }

        $scope.$on('prevNextMonthClick', function(event, actualScheduleSearchParam) {
          vm.model.fromDate = actualScheduleSearchParam.fromDate;
          vm.model.toDate = actualScheduleSearchParam.toDate;
        });

        vm.searchSchedule = function(){
          vm.searchForm.$submitted=true;
          if(vm.searchForm.$valid ){
            if( !!vm.model.crewID || !!vm.model.crewDetails){
              vm.searchCrewSchedule({'searchParam':vm.model});
            }
            else{
              MessageService.warning(MessageService.MESSAGES.CREW_SCHEDULE.SEARCH_VALIDATION_ERROR);
            }
          }


        };
        function calculateNoOfDays(){
          vm.cal_start = moment(vm.model.fromDate, "DD/MM/YYYY");
          vm.cal_end = moment(vm.model.toDate, 'DD/MM/YYYY');
          vm.model.days = vm.cal_end.diff(vm.cal_start, 'days')+1;
        };
        vm.calculateDateDiff = function(){
          calculateNoOfDays();
        };

        function setDefaultSearchDays(){
          if(!vm.model.fromDate){
            var moStart = moment().startOf("month");
            var moEnd = moment().endOf("month");
            vm.model.fromDate = moStart.format(applicationConstants.SETTINGS.DATE_FORMAT);
            vm.model.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
          }
          calculateNoOfDays();
        }
        vm.loadCrewList = function(){
          vm.model.crewID = '';
          vm.model.crewDetails ='';
          if(!!vm.model.crewType){
            vm.onChangeCrewType({
              crewType :vm.model.crewType.crewTypeCode,
              hubCode :vm.model.employerHub ? vm.model.employerHub.hubCode : "",
            });
          }
        };

        vm.loadEmployerHubList = function(){
          vm.model.hubCode = '';
          vm.model.crewDetails ='';
          if(!!vm.model.employerHub){
            vm.onChangeEmployeeHub({employerHub :vm.model.employerHub.crewTypeCode});
          }
        };

        vm.loadCrewID = function(){
          vm.model.crewID = vm.model.crewDetails.crewId;
          vm.selectedCrew = vm.model.crewDetails;
          vm.flag = 1;
        };
        vm.setToDate = function(){
          vm.model.toDate =moment(vm.model.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
          calculateNoOfDays();
        };
        vm.setToDateFromNoOfDays = function() {
          vm.model.toDate = moment(vm.model.fromDate, "DD/MM/YYYY").add(vm.model.days -1, 'd').format("DD/MM/YYYY");
        };
        vm.crewIDEntered = function () {
          if(!!vm.model.crewType){
            vm.model.crewType.crewTypeCode='';
          }
          vm.model.crewDetails='';
        }

      }],
      link: function (scope, element, attrs) {

      }
    };
  }
}());
